import React, { Fragment, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { navigate } from '@reach/router';
import { useApolloClient, useMutation} from '@apollo/react-hooks';
import * as Yup from 'yup';
import axios from 'axios';
import styles from './Pack.module.scss';
import { useEffectOnce } from 'react-use';
import bookIcon from '../../../../images/book-icon.png';
import plusCircled from '../../../../images/plus-circled.svg';

import { Button, FormErrors } from '@squirrellearningltd/go-teacher-components';

import { GET_BOOK_TYPES_QUERY, GET_S3_UPLOAD_QUERY } from '../../../../services/pack/graphql';
import { ADD_BOOK_TYPE_MUTATION } from '../../services/graphql';

const AddPack = () => {
    const [formErrors, setFormErrors] = useState([]);
    const [iconUrl, setIconUrl] = useState('');
    const [iconPreview, setIconPreview] = useState('');
    const schema = Yup.object().shape({
        name: Yup.string().required('Please enter number a pack name'),
        description: Yup.string().required('Please enter a pack description')
    });

    const client = useApolloClient();
    const formRef = useRef(null);

    const { register, handleSubmit, errors, watch, setValue, setError } = useForm({
        validationSchema: schema,
        mode: 'onBlur'
    });

    const [addPack, { loading: addingPack }] = useMutation(ADD_BOOK_TYPE_MUTATION, {
        refetchQueries: [
        { query: GET_BOOK_TYPES_QUERY, variables: { hidden: false } }],
        onCompleted: ({ addBookTemplateCategory }) => {
            if (addBookTemplateCategory.errors && addBookTemplateCategory.errors.length !== 0) {
                setFormErrors(addBookTemplateCategory.errors);
                return;
            } else if (addBookTemplateCategory.bookTemplateCategory.id) {
                navigate(`/packs`);
            }
        }
    });

    const onSubmit = values => {
        const { name, description, iconUrl, backgroundColor, textColor } = values;
        
        addPack({
            variables: {
                name,
                description,
                iconUrl,
                backgroundColor,
                textColor
            }
        });
    }

     useEffectOnce(() => {
        register('iconUrl');
        setIconPreview('');
        setIconUrl('');
    });

    const onSelectFile = (files, objectName) => {
        if (files.length) {
            const extension = files[0].name.split('.').pop().toLowerCase();
            const allowedTypes = ['jpg', 'jpeg', 'png'];
            if (!allowedTypes.includes(extension)) {
                setError('iconUrl', 'manual', 'Only .jpg, .jpeg, and .png files are allowed.');
                return;
            }

            setError('iconUrl', 'manual', '');
            const filename = `${objectName}-${new Date().getTime()}.${extension}`;
            client.query({
                query: GET_S3_UPLOAD_QUERY,
                variables: {
                    name: filename,
                    fileType: extension,
                    object: objectName
                }
            }).then(r => {
                const options = { headers: { 'Content-Type': '', 'x-amz-acl': 'public-read' } }
                axios.put(r.data.s3UploadUrlFor.uploadUrl, files[0], options).then(s3r => {
                    if (objectName === 'iconUrl') {
                        setIconUrl(r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                        setIconPreview(r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                        setValue('iconUrl', r.data.s3UploadUrlFor.uploadUrl.split('?')[0]);
                    }
                })
            })
        }
    }

    const titlePreview = watch('name');
    const messagePreview = watch('description');
    const showIconPreview = watch('iconUrl');
    const backgroundColorPreview = watch('backgroundColor');
    const textColorPreview = watch('textColor');

    return (
        <Fragment>
            <div className={styles.Header}>
                <div className={styles.TitleIconContainer}>
                    <h2 className={styles.HeaderTitle}>Categories</h2>
                     <img
                        width='20'
                        height='20'
                        src={bookIcon}
                        alt='book-icon'
                    />
                </div>
                <div>
                        <button
                            type="submit"
                            className={styles.PublishButton}
                            onClick={() => formRef.current?.requestSubmit()}
                        >
                            {addingPack ? 'Saving...' : 'Publish'}
                        </button>          
                        {/* <button              
                            className={styles.ArchiveButton}
                        >
                            Hide
                        </button>
                    <button
                        className={styles.DeleteButton}
                    >
                        Edit
                    </button> */}
                </div>
            </div>

            <div className={`${styles.NotificationContainer} u-m-top-2`}>

                <div className={styles.NotificationForm}>
                    <h2>Icon</h2>

                    <div
                        className={`${styles.notificationWrapper} ${styles.emptyNotification}`}
                    >
                        <input
                            name='iconUrl'
                            className={`${styles.fileUpload} basic-form__text-box`}
                            placeholder='Icon'
                            onChange={(e) =>
                                onSelectFile(
                                    e.target.files,
                                    'iconUrl'
                                )
                            }
                            type='file'
                            accept='.jpg,.jpeg,.png'
                        />

                        {iconUrl ? (
                            <img
                                className={styles.ArtWorkPreview}
                                src={iconPreview}
                                alt='icon-img'
                            />
                        ) : (
                            <img width='48' src={plusCircled} alt='plus-circle-svg' />
                        )}
                    </div>
                    {errors.iconUrl && <p className='basic-form__hint'>{errors.iconUrl.message}</p>}
            
                    {/* <h1 className='title u-m-top-2 u-m-base-2'>Add New Book Type</h1> */}
                    <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                        <h2>Title</h2>
                        <div className='basic-form__group'>
                            <input
                                name='name'
                                placeholder='Title'
                                className='basic-form__text-box'
                                ref={register}
                                type='text'
                            />
                            
                        </div>
                        {errors.name && <p className='basic-form__hint'>{errors.name.message}</p>}
                        <h2>Message</h2>
                        <div className='basic-form__group'>
                            <textarea
                                name='description'
                                placeholder='Message'
                                className='basic-form__text-box'
                                ref={register}
                                type='text'
                            />
                            
                        </div>
                        {errors.description && <p className='basic-form__hint'>{errors.description.message}</p>}
                        {/* <div className='basic-form__group basic-form__group--check'>
                            <input
                                name='isSingleChapter'
                                className='basic-form__check-box'
                                ref={register}
                                type='checkbox'
                            />
                            <label className='basic-form__check-label' htmlFor='isSingleChapter'>Single Chapter (e.g. for Anthology books)</label>
                        </div> */}
                        {/* <div className='basic-form__group basic-form__group--check'>
                            <label className='basic-form__label' htmlFor='resources'>Icon</label>
                            <input
                                name='iconUrl'
                                className='basic-form__text-box'
                                placeholder='Icon Image'
                                onChange={e => onSelectFile(e.target.files, 'icon_url')}
                                type='file'
                                accept='image/*'
                            />
                        </div> */}
                        <h2>Settings</h2>
                        <div className='basic-form__group'>
                            <input
                                name='backgroundColor'
                                placeholder='Background Color'
                                className='basic-form__text-box'
                                ref={register}
                                type='text'
                            />
                            
                        </div>
                        <div className='basic-form__group'>
                            <input
                                name='textColor'
                                placeholder='Text Color'
                                className='basic-form__text-box'
                                ref={register}
                                type='text'
                            />
                            
                        </div>
                        {formErrors.length !== 0 && <FormErrors errors={formErrors} />}
                        {/* <div className='u-display-flex u-align-center'>
                            <Button type='submit' className='u-m-right-1'>{addingPack ? 'Saving...' : 'Add Book type'}</Button>
                            <Button type='button' outline onClick={() => navigate('/')}>Cancel</Button>
                        </div> */}
                    </form>
                </div>

                <div className={styles.NotificationPreview}>
                
                    <h2>Preview</h2>

                    <div className={styles.PreviewCard} style={{backgroundColor: backgroundColorPreview, color: textColorPreview}}>
                        
                        {showIconPreview && iconPreview && (
                          <div className={styles.ImageContainer}>
                            <img src={iconPreview} alt="icon-preview" />
                        </div>
                        )}
                        <h3>{titlePreview}</h3>
                        <p className={`${styles.MessageElipsis} u-m-top-1`}>
                            {messagePreview}
                        </p>
                    </div>
                
                </div>
            </div>

        </Fragment>
    );
}

export default AddPack;
